<div class="d-flex justify-content-center">
  <div class="card w-100 border-0">
    <div class="card-body pt-0">
      <div class="row">
        <div class="col-12 my-2">
          <ng-container *ngIf="!isLoadingItems; else loadingItems">
            <app-shared-table
              [items]="items"
              [enablePagination]="true"
              [showBtn]="addItem"
              [enableSorting]="false"
              [initialPageSize]="size"
              [totalRecords]="totalItemCount"
              [bodyTemplate]="customBodyTemplate"
              (pageChange)="onPageChange($event)"
              (pageSizeChange)="onPageSizeChange($event)"
              (search)="onSearch($event)"
              [customTemplate]="true"
              [buttonText]="('GENERAL.CREATE' | translate) + ' ' + ('GENERAL.USER' | translate)"
              (buttonClick)="openUserDialog(null, true)"
              [HandelRenderingDataMessage]="HandelRenderingDataMessage"
            >
            </app-shared-table>
          </ng-container>
          <ng-template #customBodyTemplate let-element>
            <tr *ngIf="!isLoadingFilter; else loadingFilter">
              <!-- First Name -->
              <td>{{ element?.firstName }}</td>
              <!-- Last Name -->
              <td>{{ element?.lastName }}</td>
              <!-- Email -->
              <td>{{ element?.email }}</td>
              <!-- Account -->
              <td>{{ element?.account?.englishName }}</td>
              <!-- Specialized Roles -->
              <td>
                <ng-container *ngIf="element?.specializedRoles?.length > 0; else noSpecializedRoles">
                  <span class="d-flex gap-1 align-items-center">
                    <span class="tags-badge" *ngFor="let item of element?.specializedRoles.slice(0, 2)">
                      {{ item?.englishName }}
                    </span>
                    <span class="tags-badge" *ngIf="element?.specializedRoles?.length > 2">
                      +{{ element?.specializedRoles?.length - 2 }}
                    </span>
                  </span>
                </ng-container>
                <ng-template #noSpecializedRoles>--</ng-template>
              </td>
              <!-- System Roles -->
              <td>
                <ng-container *ngIf="element?.systemRoles?.length > 0; else noSystemRoles">
                  <span class="d-flex gap-1 align-items-center">
                    <span class="tags-badge" *ngFor="let item of element?.systemRoles.slice(0, 2)">
                      {{ item?.englishName }}
                    </span>
                    <span class="tags-badge" *ngIf="element?.systemRoles?.length > 2">
                      +{{ element?.systemRoles?.length - 2 }}
                    </span>
                  </span>
                </ng-container>
                <ng-template #noSystemRoles>--</ng-template>
              </td>
              <!-- Action Buttons -->
              @if (actionsList.length > 0) {
                <td>
                  <div class="action-btns">
                    <p-menu #menu [model]="actionsList" [popup]="true" appendTo="body">
                      <ng-template let-item pTemplate="item">
                        <li *ngIf="item?.isView" pMenuItem (click)="item.command(element)">
                          <a [attr.aria-label]="item.label" class="p-ripple p-element p-menuitem-link">
                            <span [class]="item.icon" class="p-menuitem-icon"></span>
                            <span class="p-menuitem-text">{{ item.label }}</span>
                          </a>
                        </li>
                      </ng-template>
                    </p-menu>
                    <p-button
                      (onClick)="menu.toggle($event)"
                      icon="pi pi-ellipsis-v"
                      [text]="true"
                      severity="secondary"
                    ></p-button>
                  </div>
                </td>
              }
            </tr>
          </ng-template>
          <!-- Loading Filter -->
          <ng-template #loadingFilter>
            <tr>
              <td *ngFor="let _ of items.dataKeys"><p-skeleton></p-skeleton></td>
              <td><p-skeleton></p-skeleton></td>
            </tr>
          </ng-template>
          <!-- Loading Items -->
          <ng-template #loadingItems>
            <p-skeleton width="100%" height="50px"></p-skeleton>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
